import {
	RENAME_CREATIVE,
	DOWNLOAD_CREATIVE_SUMMARY,
	DELETE_CREATIVE
} from "./EllipsisActions";

export const YOUTUBE_VAST_ELLIPSIS_ACTION_LIST = [
	[
		RENAME_CREATIVE,
		DOWNLOAD_CREATIVE_SUMMARY,
	],
	[
		DELETE_CREATIVE,
	],
];
